import { Stack, styled } from "@mui/material";
import { toolbarRailName } from "../classes.js";
const excludedProps = ["as", "cssVariables", "ownerState", "sx", "theme"];
const Root = styled(Stack, {
  name: toolbarRailName,
  overridesResolver: (_props, styles) => [styles.root],
  shouldForwardProp: (prop) => !excludedProps.includes(prop),
  slot: "Root"
})(({ cssVariables: vars }) => ({
  backgroundColor: vars.railBackgroundColor,
  borderColor: vars.railBorderColor,
  borderStyle: vars.railBorderStyle,
  borderWidth: vars.railBorderWidth,
  color: vars.railColor,
  fontFamily: vars.railFontFamily,
  gap: vars.railGap,
  height: "100%",
  minWidth: vars.railMinWidth,
  overflow: "hidden",
  paddingBottom: vars.railPaddingBottom,
  paddingTop: vars.railPaddingTop
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
